@if (this.control?.touched) {
  @for (message of this.getAllMessages()|keyvalue; track message) {
    @if (this.control.hasError(message.key)) {
      <div>{{ message.value }}</div>
    }
  }
}
